import React from 'react'

function DiamondHelp() {
  return (
    <div>DiamondHelp</div>
  )
}

export default DiamondHelp